import React, { useState, useEffect} from "react";

import UserService from "../Services/user.service";
import Bgimg from "../Assets/Images/logohp.png";

const Home =()=> {
  const [content, setcontent]= useState("");


  useEffect(() => {
    UserService.getPublicContent().then(
      res => {
        setcontent(res.data)
      },
      error => {
        setcontent(
            (error.res && error.res.data) ||
            error.message ||
            error.toString()
        );
      }
    );
    });

    return (
      
      <div className='container'>
        <div className='row'>
          <img src={Bgimg} className='img-fluid col-xs-12 col-sm-12 col-lg-12 col-xl-12'/>
        </div>
      </div>
    );
}
export default Home;